import { type Component, createApp, createSSRApp } from "vue";
/* Import the SDS components library */
import SdsComponents from "@cmu-sei/sei-design-system/dist/index.mjs";
/* Local import, wait for mount element(s) to exist in the DOM. */
import { waitForElem } from "./wait_for_elem";

export function createVueApp(selector: string, rootComponent: Component, ssr: boolean = false) {
  waitForElem(selector).then(() => {
    document.querySelectorAll(selector).forEach((el) => {
      const dataScript = (el as HTMLElement).dataset['json'];
      if (dataScript) {
        const props = JSON.parse(dataScript);
        if (ssr) {
          createSSRApp(rootComponent, props)
            .use(SdsComponents)
            .mount(el);
        } else {
          createApp(rootComponent, props)
            .use(SdsComponents)
            .mount(el);
        }
      }
    });
  });
}
